import { c as _c } from "react/compiler-runtime";
import UserPageIdentityHeaderCICRate from "@/components/user/identity/header/cic-rate/UserPageIdentityHeaderCICRate";
import UserPageRateWrapper from "@/components/user/utils/rate/UserPageRateWrapper";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { RateMatter } from "@/types/enums";
export default function UserCICTypeIconTooltipRate(t0) {
  const $ = _c(5);
  const {
    profile
  } = t0;
  let t1;
  if ($[0] !== profile) {
    t1 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={true} />;
    $[0] = profile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== profile || $[3] !== t1) {
    t2 = <div className="tw-mt-3.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-600 tw-pt-3.5"><div className="tw-flex tw-w-full tw-items-center tw-justify-between"><UserPageRateWrapper profile={profile} type={RateMatter.NIC}>{t1}</UserPageRateWrapper></div></div>;
    $[2] = profile;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}